import { getConfigTenant, isCorpTenant, useIsTravelApp } from "@capone/common";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { BackToTopButton, FloatingMenuPill, IconName } from "halifax";
import React, { useState } from "react";
import { SelectedTravelOfferScreen } from "redmond";
import { PackagesShopProgressBar } from "../../../book/components";
import { RewardsAccountSelection } from "../../../rewards/components";
import { TravelWalletDetailsBanner } from "../../../travel-wallet/components";
import { FlightList } from "../FlightList";
import { FlightShopAllFiltersModal } from "../FlightShopAllFiltersModal";
import { MobileShopHeader } from "../MobileShopHeader";
import { IMobileFlightShopProps } from "./container";
import "./styles.scss";

export const MobileFlightShop = (props: IMobileFlightShopProps) => {
  const { activeFiltersCount, selectedLodging } = props;
  const [allFiltersModalOpen, setAllFiltersModalOpen] = useState(false);

  const { isTravelApp } = useIsTravelApp();

  return (
    <Box
      className={clsx("mobile-package-flight-shop-root", {
        "travel-app": isTravelApp,
      })}
    >
      <MobileShopHeader />
      <PackagesShopProgressBar isMobile />
      {isCorpTenant(getConfigTenant()) &&
        selectedLodging?.bestOfferThisLodging && (
          <TravelWalletDetailsBanner
            offer={selectedLodging?.bestOfferThisLodging}
            className="pkg-flight-shop-offer"
            screen={SelectedTravelOfferScreen.PACKAGES_FLIGHT_SHOP}
            showButton={false}
            bannerTextType="shop"
          />
        )}
      <Box className="mobile-rewards-account-contents">
        <RewardsAccountSelection className="b2b" popoverClassName="b2b" />
      </Box>
      <FlightList />
      <>
        <FloatingMenuPill
          items={[
            {
              label: "Sort & filter",
              onClick: () => setAllFiltersModalOpen(true),
              icon: IconName.Settings,
              badge: activeFiltersCount
                ? String(activeFiltersCount)
                : undefined,
            },
          ]}
        />
        <FlightShopAllFiltersModal
          openAllFiltersModal={allFiltersModalOpen}
          setOpenAllFiltersModal={setAllFiltersModalOpen}
          isMobile
        />
        <BackToTopButton />
      </>
    </Box>
  );
};
